export const COLLAPSIBLES_ADD_COLLAPSIBLE = 'COLLAPSIBLES_ADD_NEW_COLLAPSIBLE';
export const COLLAPSIBLES_KEEP_COLLAPSIBLE = 'COLLAPSIBLES_KEEP_COLLAPSIBLE';
export const COLLAPSIBLES_REMOVE_COLLAPSIBLE = 'COLLAPSIBLES_REMOVE_COLLAPSIBLE';
export const COLLAPSIBLES_ADD_COLLAPSIBLE_ITEM = 'COLLAPSIBLES_ADD_COLLAPSIBLE_ITEM';
export const COLLAPSIBLES_KEEP_COLLAPSIBLE_ITEM = 'COLLAPSIBLES_KEEP_COLLAPSIBLE_ITEM';
export const COLLAPSIBLES_TOGGLE_COLLAPSIBLE_ITEM = 'COLLAPSIBLES_TOGGLE_COLLAPSIBLE_ITEM';
export const COLLAPSIBLES_OPEN_COLLAPSIBLE_ITEM = 'COLLAPSIBLES_OPEN_COLLAPSIBLE_ITEM';
export const COLLAPSIBLES_CLOSE_COLLAPSIBLE_ITEM = 'COLLAPSIBLES_CLOSE_COLLAPSIBLE_ITEM';

export function addCollapsible(collapsibleName, allowMultiple) {
  return {
    type: COLLAPSIBLES_ADD_COLLAPSIBLE,
    collapsibleName,
    allowMultiple,
  };
}
export function keepCollapsible(collapsibleName, allowMultiple) {
  return {
    type: COLLAPSIBLES_KEEP_COLLAPSIBLE,
    collapsibleName,
    allowMultiple,
  };
}

export function removeCollapsible(collapsibleName) {
  return {
    type: COLLAPSIBLES_REMOVE_COLLAPSIBLE,
    collapsibleName,
  };
}

export function addCollapsibleItem(collapsibleName, itemKey) {
  return {
    type: COLLAPSIBLES_ADD_COLLAPSIBLE_ITEM,
    collapsibleName,
    itemKey,
  };
}

export function keepCollapsibleItem(collapsibleName, itemKey) {
  return {
    type: COLLAPSIBLES_KEEP_COLLAPSIBLE_ITEM,
    collapsibleName,
    itemKey,
  };
}

export function toggleCollapsibleItem(collapsibleName, itemKey) {
  return {
    type: COLLAPSIBLES_TOGGLE_COLLAPSIBLE_ITEM,
    collapsibleName,
    itemKey,
  };
}

export function openCollapsibleItem(collapsibleName, itemKey) {
  return {
    type: COLLAPSIBLES_OPEN_COLLAPSIBLE_ITEM,
    collapsibleName,
    itemKey,
  };
}

export function closeCollapsibleItem(collapsibleName, itemKey) {
  return {
    type: COLLAPSIBLES_CLOSE_COLLAPSIBLE_ITEM,
    collapsibleName,
    itemKey,
  };
}
